import { HStack, Icon, Text, Image, Menu, Portal, Box } from "@chakra-ui/react";
import { HiOutlineCircleStack } from "react-icons/hi2";
import AvatarPlaceholder from '@/assets/images/avatar_placeholder.svg';
import { useAuth } from '@/auth/AuthContext';

const TopBar = () => {
    const { currentUser, logout } = useAuth();

    const displayName = currentUser
        ? `${currentUser.firstName} ${currentUser.lastName}`
        : '';

    const initials = currentUser
        ? `${currentUser.firstName?.[0] ?? ''}${currentUser.lastName?.[0] ?? ''}`.toUpperCase()
        : '';

    return (
        <HStack bg="bg.secondary" minH={20} w={'full'} justifyContent={'space-between'} alignItems={'center'} px={12}>
            <HStack>
                <Icon size={'md'} color="text.user">
                    <HiOutlineCircleStack />
                </Icon>
                <Text bg="radial-gradient(circle, #ECEDFF, #C17EEB)" bgClip="text">Scenario > Intents</Text>
            </HStack>

            <Menu.Root>
                <Menu.Trigger asChild>
                    <HStack
                        as="button"
                        color={"text.user"}
                        columnGap={3}
                        transition="background 0.2s ease-in-out"
                        _hover={{ bg: "border.primary", textDecoration: 'unset' }}
                        py={2}
                        pl={2}
                        pr={4}
                        borderRadius={32}
                        cursor="pointer"
                    >
                        {currentUser?.avatar ? (
                            <Image src={currentUser.avatar} w={8} borderRadius="full" />
                        ) : (
                            <Box
                                w={8}
                                h={8}
                                borderRadius="full"
                                bg="purple.500"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <Text fontSize={12} color="white" fontWeight="bold">{initials || <Image src={AvatarPlaceholder} w={8} />}</Text>
                            </Box>
                        )}
                        <Text fontSize={16}>{displayName}</Text>
                    </HStack>
                </Menu.Trigger>
                <Portal>
                    <Menu.Positioner>
                        <Menu.Content>
                            <Menu.Item value="logout" onClick={logout}>
                                Sign out
                            </Menu.Item>
                        </Menu.Content>
                    </Menu.Positioner>
                </Portal>
            </Menu.Root>
        </HStack>
    );
};

export default TopBar;
